import React, { useState, useEffect } from 'react';
import {
    Box,
    HStack,
    Text,
    VStack,
} from '@chakra-ui/react';

const CountdownTimer = ({ targetDate, large = false, centered = false, mode = 'full', fontSize = "xl", color = "white" }) => {
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });

    useEffect(() => {
        const calculateTimeLeft = () => {
            const now = new Date().getTime();
            const target = new Date(targetDate).getTime();
            const difference = target - now;
            
            if (difference <= 0) {
                return {
                    days: 0,
                    hours: 0,
                    minutes: 0,
                    seconds: 0
                };
            }
            
            const totalDays = Math.floor(difference / (1000 * 60 * 60 * 24));
            const totalHours = Math.floor(difference / (1000 * 60 * 60));
            const hours = totalHours % 24;
            const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((difference % (1000 * 60)) / 1000);
            
            return {
                days: totalDays,
                hours,
                minutes,
                seconds
            };
        };

        setTimeLeft(calculateTimeLeft());
        const timer = setInterval(() => {
            const newTimeLeft = calculateTimeLeft();
            setTimeLeft(newTimeLeft);
            
            if (newTimeLeft.days === 0 && 
                newTimeLeft.hours === 0 && 
                newTimeLeft.minutes === 0 && 
                newTimeLeft.seconds === 0) {
                clearInterval(timer);
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [targetDate]);

    return (
        <HStack spacing={1} justify={centered ? "center" : "flex-start"}>
            <Text
                fontSize={fontSize}
                fontWeight="bold"
                color={color}
                fontFamily="Aclonica"
                lineHeight="1"
                letterSpacing="0"
                whiteSpace="nowrap"
                sx={{
                    '& > span': {
                        display: 'inline-block',
                        width: '1.5em',
                        textAlign: 'center'
                    },
                    '& > span.colon': {
                        width: '0.5em'
                    }
                }}
            >
                <span>{String(timeLeft.days).padStart(2, '0')}</span>
                <span className="colon">:</span>
                <span>{String(timeLeft.hours).padStart(2, '0')}</span>
                <span className="colon">:</span>
                <span>{String(timeLeft.minutes).padStart(2, '0')}</span>
                <span className="colon">:</span>
                <span>{String(timeLeft.seconds).padStart(2, '0')}</span>
            </Text>
        </HStack>
    );
};

export default CountdownTimer;
